import { AuthenticatedGuard } from './authenticated.guard';
import { GlobalAdminGuard } from './global-admin.guard';
import { OrganisationMemberGuard } from './organisation-member.guard';
import { GroupAdminGuard } from './group-admin.guard';
import { UnauthenticatedGuard } from './unauthenticated.guard';
import { TenantManagerGuard } from './tenant-manager.guard';

export * from './authenticated.guard';
export * from './global-admin.guard';
export * from './group-admin.guard';
export * from './tenant-manager.guard';
export * from './organisation-member.guard';

export const GUARDS = [
  AuthenticatedGuard,
  GlobalAdminGuard,
  GroupAdminGuard,
  OrganisationMemberGuard,
  TenantManagerGuard,
  UnauthenticatedGuard,
];
